import { render, staticRenderFns } from "./SpotlightCard.vue?vue&type=template&id=f5d04640&scoped=true&"
import script from "./SpotlightCard.vue?vue&type=script&lang=js&"
export * from "./SpotlightCard.vue?vue&type=script&lang=js&"
import style0 from "./SpotlightCard.vue?vue&type=style&index=0&id=f5d04640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d04640",
  null
  
)

export default component.exports